export const pickListTheme = {
  extend: {
    agility: {
      header: {
        background: 'var(--p-surface-100)',
        color: 'var(--text-color)',
      },
    },
    colorScheme: {
      dark: {
        agility: {
          header: {
            background: 'var(--p-surface-900)',
          },
        },
      },
    },
  },
  css: ({ dt }: any) => `
  .p-picklist .p-picklist-list-container {
   max-height: 100%;
  }
  .p-picklist .p-listbox-header-custom {
    background: ${dt('picklist.agility.header.background')};
    color: ${dt('picklist.agility.header.color')};
    padding: var(--rem);
    border-top-right-radius: var(--border-radius);
    border-top-left-radius: var(--border-radius);
  }
  `,
};
